import { render } from "./VacsChart.vue?vue&type=template&id=4939f3aa&scoped=true"
import script from "./VacsChart.vue?vue&type=script&lang=js"
export * from "./VacsChart.vue?vue&type=script&lang=js"

import "./VacsChart.vue?vue&type=style&index=0&id=4939f3aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4939f3aa"]])

export default __exports__